import store from '~/redux/user/store';
import { setParentalControls, enableDisableParentalControl } from '~/redux/user/actions';

export const setParentalControlToggle = async (getToggleFlag) => {
    const parentalControlData = { 'parentalControl': !getToggleFlag };

    return await setParentalControls(parentalControlData)
    .then(ParentalControlRes => { 
        if (ParentalControlRes && ParentalControlRes.status === 200) {
            store.dispatch(enableDisableParentalControl(!getToggleFlag))
            return true;
        } else {
            return false;
        }
    })
    .catch( error => {
        console.error(error)
        return false;
    })
}